import React from 'react';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, ImageAvatar, SquareChip, TagsArray, Text, useSettings } from 'app/main/components';
import { DurationSquareChip } from 'app/main/components/list-items';
import buttons from './WorkReportsButtons';
import WorkReportsDates from './components/WorkReportsDates';

export default function WorkReportsListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="companies"
			uid={props.model.wore_comp_uid}
			avatar={props.model.comp_avatar}
			initials={props.model.wore_title_initials}
			labelBadge={props.model.wost_title_initials}
			labelBadgeTooltip={props.model.wost_title}
			badgeColor={props.model.wost_color}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={props.width >= 960 ? 8 : 12}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.wore_warning_desc && (
								<Tooltip title={props.model.wore_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.wore_blocked_desc && (
								<Tooltip title={props.model.wore_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'workreports', uid: props.model.wore_uid }}
							>
								{props.model.comp_title && `${props.model.comp_title} - `}
								{props.model.wore_title}
							</Text>
						</Grid>
						{/* TYPE */}
						<Grid>
							{props.model.woty_title && (
								<SquareChip label={props.model.woty_title} backgroundColor={props.model.woty_color} />
							)}
						</Grid>
						{/* DATE FROM - TO */}
						<Grid>
							<WorkReportsDates
								date={props.model.wore_date}
								from={props.model.wore_hour_from}
								to={props.model.wore_hour_to}
							/>
						</Grid>
						{/* DURATION */}
						{(props.model.wore_length_hours > 0 || props.model.wore_length_minutes > 0) && (
							<Grid>
								<DurationSquareChip
									id="workReportsListItem.expectedDuration"
									defaultMessage={t('DURATION')}
									duration={{
										hours: props.model.wore_length_hours,
										minutes: props.model.wore_length_minutes
									}}
								/>
							</Grid>
						)}
						{/* TAGS */}
						<Grid>
							<TagsArray tags={props.model.wore_tags} changeFilter={props.changeFilter} />
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 600 && (
					<Grid size={4}>
						<Grid container>
							{/* COMPANY */}
							<Grid size={12}>
								<ButtonLink
									href={`/companies/details/${props.model.wore_comp_uid}`}
									icon="domain"
									fallback={t('VIEW_ITEM_NO_COMPANY')}
								>
									{props.model.comp_title}
								</ButtonLink>
							</Grid>
							{/* INTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={`/users/details/${props.model.wore_user_assigned_uid}`}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_INTUSER')}
								>
									{props.model.user_assigned_title}
								</ButtonLink>
							</Grid>
						</Grid>
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
